<template>
  <div class="body">
    <div class="title">
      添加账号
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item  :to="{ path: '/zhanghaoguanli' }">账号管理</el-breadcrumb-item>
          <el-breadcrumb-item>添加账号</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first">
          <div class="fromsss">
            <el-form ref="form" :model="addQuery" label-width="80px" :rules="resetFormRules"   :label-position="labelPosition" @submit.native.prevent>
              <el-form-item label="发布者名称" label-width="10%">
                <el-input style="width: 294px;" placeholder="注册后不可修改，可用于登录" v-model="addQuery.username" disabled></el-input>
              </el-form-item>
              <el-form-item label="头像" label-width="10%">
                <div class="imgbox" v-if="addQuery.userface !== ''">
                  <img :src="addQuery.userface" alt="" class="imgs">
                  <img src="../../assets/img/shanchu.png" mode="" class="close"
                       @click="closeImgs" v-if="addQuery.userface !== ''">
                </div>
                <el-upload
                  v-if="addQuery.userface === ''"
                  class="upload-demo"
                  ref="upload"
                  action="/service/admin/upload_pic"
                  :on-progress="progress"
                  :on-success="handleAvatarSuccess"
                  :limit="1"
                  :before-upload="beforeUpload"
                  :on-exceed="handleExceed"
                  list-type="picture"
                  :data="{token:token}"
                  name='pic'
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="姓名" label-width="10%">
                <el-input style="width: 294px;" placeholder="请输入姓名" v-model="addQuery.realname"></el-input>
              </el-form-item>
              <el-form-item label="手机号" label-width="10%">
                <el-input style="width: 294px;" placeholder="请输入手机号" v-model="addQuery.mobile"></el-input>
              </el-form-item>
              <el-form-item label="密码 " prop="newuserpass"  label-width="10%">
                <el-input style="width: 294px;" v-model="addQuery.userpass" placeholder="请输入密码" auto-complete="off" show-password clearable></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="renewuserpass" label-width="10%">
                <el-input style="width: 294px;" v-model="addQuery.reuserpass" placeholder="请确认密码" auto-complete="off" show-password clearable></el-input>
              </el-form-item>
            </el-form>
            <el-button type="primary"  size="medium" @click="addUser">选择</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="账号权限" name="second">
          <div class="fromsss">
            <el-form ref="form" label-width="80px"   :label-position="labelPosition" @submit.native.prevent>
              <el-form-item label="权限列表" label-width="10%">
                <el-tree
                  v-model="quanxianAdd.limit"
                  ref="tree"
                  :data="quanxianList"
                  :props="prop"
                  :accordion="true"
                  :expand-on-click-node="true"
                  :highlight-current="true"
                  show-checkbox
                  current-node-key="id"
                  node-key="id"
                  @check-change="handleCheckChange"
                >
                </el-tree>
              </el-form-item>
            </el-form>
            <el-button type="primary"  size="medium" @click="tianjiaquanxian">选择</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  adminuserLimits,
  updateAdminuserlimit,
  adminuserView,
  updateAdminuser
} from '@/api/zhanghaoguanli'
import { mapState } from 'vuex'
export default {
  name: 'index',
  computed: {
    ...mapState(['quanxianID'])
  },
  data () {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (value.toString().length < 6 || value.toString().length > 18) {
        callback(new Error('密码长度为6-18位'))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.addQuery.newuserpass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isChecked: false,
      prop: {
        value: 'id',
        label: 'name',
        children: 'sub_menu',
        checkStrictly: true, // 可以选择任意一级
        expandTrigger: 'hover'
      },
      resetFormRules: {
        newuserpass: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        renewuserpass: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
      token: sessionStorage.getItem('token'),
      activeName: 'first',
      labelPosition: 'left',
      addQuery: {
        token: sessionStorage.getItem('token'),
        username: '',
        userface: '',
        realname: '',
        mobile: '',
        userpass: '',
        reuserpass: ''
      },
      quanxianList: [],
      quanxianAdd: {
        limit: []
      }
    }
  },
  created () {
    this.xiangqinccg()
    this.quanxianLiebiao()
  },
  methods: {
    xiangqinccg () {
      const obj = {
        token: sessionStorage.getItem('token'),
        user_id: this.quanxianID
      }
      adminuserView(obj).then(({ data: res }) => {
        console.log('resccsacxsa', res)
        this.addQuery = res
        const cc = res.userlimits.split(',')
        console.log(cc.map(Number))
        this.quanxianAdd.limit = cc.map(Number)
        this.$refs.tree.setCheckedKeys(this.quanxianAdd.limit)
        console.log('this.quanxianAdd.limit', this.quanxianAdd.limit)
      })
    },
    tianjiaquanxian () {
      const obj = {
        token: sessionStorage.getItem('token'),
        user_id: this.quanxianID,
        limit: JSON.stringify(this.quanxianAdd.limit).replace(/\[|]/g, '')
      }
      updateAdminuserlimit(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$store.commit('setquanxianID', res.user_id)
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
        }
      })
    },
    addUser () {
      const obj = {
        token: sessionStorage.getItem('token'),
        user_id: this.quanxianID,
        userface: this.addQuery.userface,
        realname: this.addQuery.realname,
        mobile: this.addQuery.mobile,
        userpass: this.addQuery.userpass,
        reuserpass: this.addQuery.reuserpass
      }
      updateAdminuser(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.xiangqinccg()
        }
      })
    },
    handleCheckChange (data, checked, indeterminate) {
      this.isChecked = checked
      // 这里是node-key="xxxxx"绑定的数据，我绑定的是每个员工id
      // console.log('pri_id原数组', this.$refs.tree.getCheckedKeys())
      // 过滤最外层id（下方图片2位数字的）
      this.quanxianAdd.limit = this.$refs.tree.getCheckedKeys()
      console.log('this.addQuery.limit', this.quanxianAdd.limit)
      const employeeIdArr = this.$refs.tree.getCheckedKeys().filter(item => {
        return item.length !== 2
      })
      // console.log(employeeIdArr.join(','))
      this.employeeId = employeeIdArr.join(',')
    },
    quanxianLiebiao () {
      const obj = {
        token: sessionStorage.getItem('token')
      }
      adminuserLimits(obj).then(({ data: res }) => {
        console.log('res', res.list)
        this.quanxianList = res.list
      })
    },
    closeImgs () {
      this.addQuery.userface = ''
    },
    handleAvatarSuccess (response, file, fileList) {
      console.log('res', response)
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: 'success',
          duration: '2000'
        })
        this.addQuery.userface = response.pic_url
        console.log('this.editQuery.userface ', this.addQuery.userface)
      }
    },
    beforeUpload (file) {
      console.log(file)
      const promise = new Promise((resolve) => {
        this.$nextTick(function () {
          resolve(true)
        })
      })
      return promise // 通过返回一个promis对象解决
    },
    progress (event, file, fileList) {
      console.log('event', event, 'file', file, 'fileList', fileList)
      // this.addquery.font_url.push({ name: file })
    },
    // 文件数量过多时提醒
    handleExceed () {
      // this.$message({ type: 'info', message: '最多支持5个附件上传' })
    }
  }
}
</script>

<style lang="less">
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display:flex;
    flex-direction: row;
    align-items: center;
    .fansk{
      margin-top: 30px;
      margin-left: 32px;
    }
  }
  .fromsss{
    margin-top: 54px;
  }
}
.el-upload-list--picture .el-upload-list__item{
  display: none;
}
.file{
  display: none;
}
.fromsss{
  margin-top: 54px;
}
.imgbox{
  width: 88px;
  height: 88px;
  opacity: 1;
  background: rgba(0,0,0,0.00);
  border-radius: 5px;
  position: relative;
  .imgs{
    width: 100%;
    height: 100%;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    opacity: 1;
    background: #e54848;
    border-radius: 50%;
  }
}
</style>
